var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tabs",staticClass:"scrollBarWrapper",style:(_vm.scrollBarWrapperStyle)},[_c('div',{ref:"scrollBarContent",staticClass:"scrollBarContent",class:_vm.direction === 'y' ? 'directionY' : 'directionX'},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }